
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class CO2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/widget/aa9fbe32-1f4d-416c-8f07-e8adf72f26ed'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default CO2;